module.exports = __webpack_public_path__ + "static/img/sexual_violence.885a9810.png";